module.exports = __webpack_public_path__ + "static/06-0874d823707e0733312c9a472e9a6bdc.jpg";